module.exports = __webpack_public_path__ + "img/dead.2631700e.png";